export default __webpack_public_path__ + "static/media/feature3_2.c36dc530.png";